import { render } from "./CadastrarColuna.vue?vue&type=template&id=6a306f6e&scoped=true"
import script from "./CadastrarColuna.vue?vue&type=script&lang=js"
export * from "./CadastrarColuna.vue?vue&type=script&lang=js"

import "./CadastrarColuna.vue?vue&type=style&index=0&id=6a306f6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a306f6e"]])

export default __exports__